import styled from 'styled-components';
import spacing from '../../../theme/shared/spacing';
import Input from '../../Atoms/Input/Input';
import Text from '../../Atoms/Text/Text';
var ESUWrapper = styled.div.withConfig({
  displayName: "EmailSignUpstyle__ESUWrapper",
  componentId: "w2b8yk-0"
})(["display:flex;flex-direction:column;font-size:", ";color:", ";background-color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontSize('s');
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.color('white');
}, function (_ref3) {
  var theme = _ref3.theme,
      backgroundColor = _ref3.backgroundColor;
  return theme.color(backgroundColor);
});
var TopCopyWrapper = styled.div.withConfig({
  displayName: "EmailSignUpstyle__TopCopyWrapper",
  componentId: "w2b8yk-1"
})(["display:flex;margin-bottom:", ";"], spacing('md'));
var ButtonWrapper = styled.div.withConfig({
  displayName: "EmailSignUpstyle__ButtonWrapper",
  componentId: "w2b8yk-2"
})(["margin-top:", ";button{border-color:", ";width:100%;font-size:", ";@media ", "{width:auto;}}"], spacing('md'), function (_ref4) {
  var theme = _ref4.theme,
      backgroundColor = _ref4.backgroundColor;
  return theme.color(backgroundColor);
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontSize('s');
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.breakpoint('small');
});
var PrivacyCopyWrapper = styled.div.withConfig({
  displayName: "EmailSignUpstyle__PrivacyCopyWrapper",
  componentId: "w2b8yk-3"
})(["display:flex;flex-direction:column;margin-top:", ";p{font-size:", ";line-height:", ";a{font-size:", ";}}"], spacing('md'), function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontSize('s');
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.fontSize('xl');
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.fontSize('s');
});
var Form = styled.form.withConfig({
  displayName: "EmailSignUpstyle__Form",
  componentId: "w2b8yk-4"
})(["display:flex;flex-direction:column;margin:", " 0;"], spacing('md'));
var InputField = styled(Input).withConfig({
  displayName: "EmailSignUpstyle__InputField",
  componentId: "w2b8yk-5"
})(["width:100%;"]);
var Title = styled(Text).withConfig({
  displayName: "EmailSignUpstyle__Title",
  componentId: "w2b8yk-6"
})(["margin-bottom:", ";"], spacing('m'));
export { ESUWrapper, TopCopyWrapper, PrivacyCopyWrapper, ButtonWrapper, Form, InputField, Title };